import {InstructionalSequenceTypesEnum} from '@/shared/enums/instructionalSequenceTypesEnum';
import type {StateModel} from '@/shared/features/states/state.model';

export const baseURL = import.meta.env.VITE_API_URL ?? '/api';

export const appName = import.meta.env.VITE_APP_NAME;

export const lessonPlayerURL = import.meta.env.VITE_LESSON_PLAYER_URL;
export const resourcesPlayerURL = import.meta.env.VITE_PLAYER_RESOURCES_URL;
export const pdfPlayerURL = import.meta.env.VITE_PDF_PLAYER_URL;
export const pdfPlayerAssetsVersion = import.meta.env.VITE_PDF_ASSETS_VERSION;

export const BOOTSTRAP_ALERTS = [
   'primary',
   'secondary',
   'success',
   'danger',
   'warning',
   'info',
   'light',
   'dark',
];

export const deprecatedQueryFields = [
   'total',
   'current_page',
   'last_page',
   'from',
   'to',
   'links',
   'path',
];

export const instructionalSequencesCreatedBy = [
   {id: InstructionalSequenceTypesEnum.OWNER, name: 'Teacher'},
   {id: InstructionalSequenceTypesEnum.SHARED, name: 'Shared'},
   {id: InstructionalSequenceTypesEnum.GLOBAL, name: 'Gateway2Achieve'},
];

export const states: StateModel[] = [
   {id: 1, name: 'Alabama', abbrev: 'AL'},
   {id: 2, name: 'Alaska', abbrev: 'AK'},
   {id: 3, name: 'Arizona', abbrev: 'AZ'},
   {id: 4, name: 'Arkansas', abbrev: 'AR'},
   {id: 5, name: 'California', abbrev: 'CA'},
   {id: 6, name: 'Colorado', abbrev: 'CO'},
   {id: 7, name: 'Connecticut', abbrev: 'CT'},
   {id: 8, name: 'Delaware', abbrev: 'DE'},
   {id: 9, name: 'Florida', abbrev: 'FL'},
   {id: 10, name: 'Georgia', abbrev: 'GA'},
   {id: 11, name: 'Hawaii', abbrev: 'HI'},
   {id: 12, name: 'Idaho', abbrev: 'ID'},
   {id: 13, name: 'Illinois', abbrev: 'IL'},
   {id: 14, name: 'Indiana', abbrev: 'IN'},
   {id: 15, name: 'Iowa', abbrev: 'IA'},
   {id: 16, name: 'Kansas', abbrev: 'KS'},
   {id: 17, name: 'Kentucky', abbrev: 'KY'},
   {id: 18, name: 'Louisiana', abbrev: 'LA'},
   {id: 19, name: 'Maine', abbrev: 'ME'},
   {id: 20, name: 'Maryland', abbrev: 'MD'},
   {id: 21, name: 'Massachusetts', abbrev: 'MA'},
   {id: 22, name: 'Michigan', abbrev: 'MI'},
   {id: 23, name: 'Minnesota', abbrev: 'MN'},
   {id: 24, name: 'Mississippi', abbrev: 'MS'},
   {id: 25, name: 'Missouri', abbrev: 'MO'},
   {id: 26, name: 'Montana', abbrev: 'MT'},
   {id: 27, name: 'Nebraska', abbrev: 'NE'},
   {id: 28, name: 'Nevada', abbrev: 'NV'},
   {id: 29, name: 'New Hampshire', abbrev: 'NH'},
   {id: 30, name: 'New Jersey', abbrev: 'NJ'},
   {id: 31, name: 'New Mexico', abbrev: 'NM'},
   {id: 32, name: 'New York', abbrev: 'NY'},
   {id: 33, name: 'North Carolina', abbrev: 'NC'},
   {id: 34, name: 'North Dakota', abbrev: 'ND'},
   {id: 35, name: 'Ohio', abbrev: 'OH'},
   {id: 36, name: 'Oklahoma', abbrev: 'OK'},
   {id: 37, name: 'Oregon', abbrev: 'OR'},
   {id: 38, name: 'Pennsylvania', abbrev: 'PA'},
   {id: 39, name: 'Rhode Island', abbrev: 'RI'},
   {id: 40, name: 'South Carolina', abbrev: 'SC'},
   {id: 41, name: 'South Dakota', abbrev: 'SD'},
   {id: 42, name: 'Tennessee', abbrev: 'TN'},
   {id: 43, name: 'Texas', abbrev: 'TX'},
   {id: 44, name: 'Utah', abbrev: 'UT'},
   {id: 45, name: 'Vermont', abbrev: 'VT'},
   {id: 46, name: 'Virginia', abbrev: 'VA'},
   {id: 47, name: 'Washington', abbrev: 'WA'},
   {id: 48, name: 'West Virginia', abbrev: 'WV'},
   {id: 49, name: 'Wisconsin', abbrev: 'WI'},
   {id: 50, name: 'Wyoming', abbrev: 'WY'},
   {id: 51, name: 'District of Columbia', abbrev: 'DC'},
];
